<template>
  <section class="thanks">
    <div class="inner">
      <svg width="96" height="72" viewbox="0 0 96 72">
        <use xlink:href="#dd"></use>
      </svg>
      <paragraph-header size="1">
        {{ $t('Thank You!') }}<br />
        {{ $t('Your reservation was successful.') }}
      </paragraph-header>
      <p>{{ $t('Please check your email with the reservation details.') }}</p>
      <p>{{ $t('Your reservation number is #{number}', { number: reservationId }) }}</p>
    </div>
  </section>
</template>

<script>
import ParagraphHeader from '../atoms/ParagraphHeader.vue'
export default {
  components: { ParagraphHeader },
  props: ['reservationId'],
}
</script>

<style lang="scss" scoped>
.thanks {
  .inner {
    @include container();

    h1 {
      max-width: 600px;
      margin: 40px 0 30px;
    }

    p {
      @include fontStyleCopyRegular;
    }
  }
}
</style>
